import { useEffect } from "react";

/*
 * usePageTitle
 * ------------
 * Sets document.title while the component is mounted and restores the
 * previous title on unmount. Standardises every page under the
 * "Page Name | Get Virtual Growth" pattern.
 *
 * Usage:
 *   usePageTitle("The Journey");
 *   // sets: "The Journey | Get Virtual Growth"
 *
 *   usePageTitle("Field Notes", { suffix: null });
 *   // sets: "Field Notes"  (opt-out of suffix)
 */
const BRAND = "Get Virtual Growth";
const SEP = " | ";

export function usePageTitle(pageName, { suffix = BRAND } = {}) {
  useEffect(() => {
    const previous = document.title;
    const next = suffix ? `${pageName}${SEP}${suffix}` : pageName;
    document.title = next;
    return () => {
      document.title = previous || BRAND;
    };
  }, [pageName, suffix]);
}

export default usePageTitle;
